/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_At_OriginInputs */

const en_status_at_origin = /** @type {(inputs: Status_At_OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At Origin`)
};

const es_status_at_origin = /** @type {(inputs: Status_At_OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En origen`)
};

/**
* | output |
* | --- |
* | "At Origin" |
*
* @param {Status_At_OriginInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_at_origin = /** @type {((inputs?: Status_At_OriginInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_At_OriginInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_at_origin(inputs)
	return es_status_at_origin(inputs)
});